import { UNREAD_CATEGORY_ID } from '../const/unread-category';
import { ViewCategory } from '../model/view-category.model';
import { ViewItem } from '../model/view-item.model';

export function determineUnread(
    categories: ViewCategory[],
    items: ViewItem[],
): ViewCategory[] {
    return categories.map((e, ei) => {
        const count =
            items?.filter(
                (i) =>
                    (e.categoryId === UNREAD_CATEGORY_ID ||
                        i.categoryId === e.categoryId) &&
                    !i.read &&
                    !i.deleted,
            )?.length ?? 0;
        return {
            ...e,
            unreadCount: count,
            unreadCountLabel: count > 9 ? '9+' : `${count}`,
        };
    });
}
